import * as React from 'react';
import {
    List,
    Datagrid,
    TextField,
    BooleanField,
    TextInput,
    TopToolbar,
    useNotify,
    useRefresh,
    useRecordContext,
    Edit,
} from 'react-admin';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import useIsPermission from '../../hooks/useIsPermission';
import { goApi } from '../../services';
import { useNavigate } from 'react-router';

const EditButton = () => {
    const navigate = useNavigate();
    const record: any = useRecordContext<any>();

    return <Button  onClick={(e) => {
        navigate(`/cron-jobs/${record?.id}`)
    }}>
        Edit
    </Button>

};

const CronJobsList = () => {
    // const { isUpdatable } = useIsPermission('');
    const notify = useNotify();
    const refresh = useRefresh();

    const filters = [
        <TextInput
            label="Search by Name"
            source="name"
            alwaysOn
            fullWidth
        />,
    ];

    const handleReload = async () => {
        try {
            await goApi.post('/cron-jobs/reload');

            notify('Cron jobs reloaded successfully', { type: 'success' });
            refresh();
        } catch (error: any) {
            notify(
                error?.message || 'Failed to reload cron jobs',
                { type: 'error' }
            );
        }
    };

    const CustomActions = () => (
        <TopToolbar>
            <Button
                variant="contained"
                startIcon={<RefreshIcon />}
                onClick={handleReload}
            >
                Reload
            </Button>
        </TopToolbar>
    );

    return (
        <List
            resource="cron-jobs"
            actions={<CustomActions />}
            filters={filters}
            queryOptions={{
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
            }}
        >
            <Datagrid rowClick="edit">
                <TextField source="name" />
                <TextField source="schedule" />
                <BooleanField source="isActive" />
                <FormattedDateTimeField source="lastRunAt" />
                <FormattedDateTimeField source="createdAt" />
                <FormattedDateTimeField source="updatedAt" />
                <EditButton />
            </Datagrid>
        </List>
    );
};

export default CronJobsList;